import { Group, Layer, Rect } from 'react-konva';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { Size } from '../../../../core/types/ui/size';
import { IPosition2d } from '../../../../core/types/ui/position';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { getFreezeBarHandleSize } from '../../../utils/viewport/viewportUtils';
import useKonvaCursor, {
  CursorTypes,
} from '../../../../core/hooks/useKonvaCursor';

// const { freezeBarHandleSize } = SheetDefaults;

interface FreezeLineKonvaProps
  extends Size,
    IPosition2d,
    ReturnTypeofSheetSectionsSelector,
    Pick<UseSheetTheme, 'stroke' | 'isRtl'> {}
const FrozenLines: React.FC<FreezeLineKonvaProps> = ({
  x,
  y,
  width,
  height,
  freezedCols,
  freezedRows,
  freezedColsSum,
  freezedRowsSum,
  stroke,
  isRtl,
  zoom,
  ...props
}) => {
  // const { onMouseEnter, onMouseLeave } = useKonvaCursor();
  const freezeBarHandleSize = getFreezeBarHandleSize(freezedCols, zoom);
  let top =
    freezedRowsSum +
    // props.groupBarHeight +
    props.colFilterHeight +
    props.colHeaderHeight;
  const leftSum = freezedColsSum + props.rowHeaderWidth;
  let left = isRtl ? width - leftSum - freezeBarHandleSize : leftSum;

  const drawLine = (x: number, y: number, height: number, width: number) => (
    <Rect
      x={x}
      y={y}
      width={width}
      height={height}
      fill={stroke}
      // onMouseEnter={(e) => onMouseEnter(e, CursorTypes.Grab)}
      // onMouseLeave={onMouseLeave}
    />
  );

  return (
    <Group>
      {freezedRows.frozen && drawLine(x, top, freezeBarHandleSize, width)}
      {freezedCols.frozen && drawLine(left, y, height, freezeBarHandleSize)}
    </Group>
  );
  // return <Rect {...props} fill={stroke} />;
};

// / y + props.groupBarHeight
export default FrozenLines;
